import { Constraint, Identifiable, OptimizedGantt, Task } from "@planzone/dto";

function isTaskLate({ endDate }: Identifiable<Task>) {
  return endDate && new Date(endDate) < new Date();
}

function isTaskDone({ percentComplete, status }: Identifiable<Task>) {
  return percentComplete === 100 || status.percentComplete === 100;
}

function isBlocked(
  element: Identifiable<Task>,
  constraints: (Identifiable<Constraint> & {
    targetStartDate: string;
    targetEndDate: string;
    targetIsDone: boolean;
    originStartDate: string;
    originEndDate: string;
    originIsDone: boolean;
  })[],
) {
  return !!constraints.find(
    ({ targetEntityUuid, originDateType, targetDateType, originIsDone }) =>
      targetEntityUuid === element.uuid &&
      originDateType === "END" &&
      targetDateType === "START" &&
      !originIsDone,
  );
}
export { isTaskLate, isTaskDone, isBlocked };
